export default "__VITE_ASSET__YjP0T2_m__"